import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { ListingsFacade } from '@app/shared/+state/listings';
import { LoadingState, UpdatePropertyOption } from '@app/shared/interfaces';
import { Observable, of } from 'rxjs';
import { toPlatformLabel } from '@app/shared/utils/lib/general.util';

@Component({
  standalone: false,
  selector: 'sbnb-connect-complete',
  templateUrl: './connect-complete.component.html',
  styleUrls: ['./connect-complete.component.scss'],
})
export class ConnectCompleteComponent implements OnInit {
  isMobile: boolean;
  perms$ = this.userPermissionsService;

  pageLoadingState$: Observable<LoadingState> = of(LoadingState.Success);
  LoadingState = LoadingState;
  platformString: string; // Friendly platform name

  listingReviewsToBeMergedLoadingStateCount$: Observable<any>;
  listingReviewsToBeMutedLoadingStateCount$: Observable<any>;
  listingReviewsToBeUnMutedLoadingStateCount$: Observable<any>;
  listingReviewsToBeCreatedLoadingStateCount$: Observable<any>;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly userPermissionsService: UserPermissionsService,
    private readonly route: ActivatedRoute,
    private listingsFacade: ListingsFacade
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const platform = params['platform'];
      this.platformString = toPlatformLabel(platform);
    });

    this.listingReviewsToBeMergedLoadingStateCount$ = this.listingsFacade.listingReviewsFormLoadingStateCountByAction$(
      UpdatePropertyOption.MergeProperty
    );
    this.listingReviewsToBeMutedLoadingStateCount$ = this.listingsFacade.listingReviewsFormLoadingStateCountByAction$(
      UpdatePropertyOption.MuteProperty
    );
    this.listingReviewsToBeUnMutedLoadingStateCount$ = this.listingsFacade.listingReviewsFormLoadingStateCountByAction$(
      UpdatePropertyOption.UnmuteProperty
    );
    this.listingReviewsToBeCreatedLoadingStateCount$ = this.listingsFacade.listingReviewsFormLoadingStateCountByAction$(
      UpdatePropertyOption.CreateNewProperty
    );

    this.watchForScreenSizeChanges();
  }

  watchForScreenSizeChanges() {
    this.breakpointObserver.observe(['(max-width: 960px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });
  }
}
